export default __webpack_public_path__ + "static/media/aboutBg.c0b06859.jpg";